import { Component, OnInit, Input  } from '@angular/core';
import {ComponentAsElement} from "../../services/common/bootstrap/annotation/component-as-element";
import {SubscriptionsHistoryService} from "../../services/subscriptions-history.service";
import {SubscriptionOrder, SubscriptionsHistory} from "../../model/subscriptionsOrders";

@ComponentAsElement('v-subscriptions-history-element')
@Component({
  selector: 'v-subscriptions-history',
  templateUrl: './subscriptions-history.component.html'
})
export class SubscriptionsHistoryComponent {
  @Input() guid: string;
  @Input() historyUrl: string;
  @Input() orderUrl: string;
  @Input() recurring: string;
  orders: (SubscriptionOrder)[] = [];
  hasMoreOrders = true;
  offset = 0;
  processing = false;

  constructor(private subscriptionsHistoryService: SubscriptionsHistoryService) {
  }

  getMoreOrders() {
    this.processing = true;
    this.subscriptionsHistoryService.getOrders(this.guid, this.offset).subscribe((data: SubscriptionsHistory) => {
      const newOrders = [...this.orders, ...data.orders];

      this.orders = newOrders;
      this.hasMoreOrders = data.hasMoreOrders;
      this.offset += data.orders.length;
      this.processing = false;
    });
  }
}
